import LandingHeader from '@/components/landing/LandingHeader';
import HeroSection from '@/components/landing/HeroSection';
import HowItWorksSection from '@/components/landing/HowItWorksSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import SocialProofSection from '@/components/landing/SocialProofSection';
import { FeedbackSection } from '@/components/landing/FeedbackSection';
import PricingSection from '@/components/landing/PricingSection';
import FAQSection, { faqs } from '@/components/landing/FAQSection';
import CTASection from '@/components/landing/CTASection';
import LandingFooter from '@/components/landing/LandingFooter';
import ParallaxPattern from '@/components/landing/ParallaxPattern';
import ScrollProgressBar from '@/components/landing/ScrollProgressBar';
import { Seo } from '@/components/Seo';
import HintLadderDemo from '@/components/landing/HintLadderDemo';
import SubjectExplorer from '@/components/landing/SubjectExplorer';
import PersonaSwitcher from '@/components/landing/PersonaSwitcher';

// Reusable section blend — fades the bottom of a section into the next
function SectionBlend() {
  return (
    <div
      className="pointer-events-none -mt-24 h-24 relative z-10"
      style={{
        background: 'linear-gradient(to bottom, transparent, hsl(var(--background)))',
      }}
    />
  );
}

export default function Landing() {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="UnlockEd — TASC-aligned AI tutor for Tasmanian students"
        description="AI tutoring built in Tasmania for TCE students in Years 10–12. Hints-first help, TASC-aligned practice and progress tracking."
        path="/"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'EducationalOrganization',
            name: 'UnlockEd Tutoring',
            url: 'https://unlockedtutoring.com.au',
            description:
              'TASC-aligned AI tutoring platform for Tasmanian senior secondary students (Years 10–12).',
          areaServed: [
            {
              '@type': 'State',
              name: 'Tasmania',
              containedInPlace: { '@type': 'Country', name: 'Australia' },
            },
            { '@type': 'City', name: 'Hobart' },
            { '@type': 'City', name: 'Launceston' },
            { '@type': 'City', name: 'Devonport' },
            { '@type': 'City', name: 'Burnie' },
          ],
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'Launceston',
              addressRegion: 'TAS',
              addressCountry: 'AU',
            },
            email: 'support@unlockedtutoring.com.au',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: { '@type': 'Answer', text: faq.answer },
            })),
          },
        ]}
      />
      <ScrollProgressBar />
      <LandingHeader />
      
      {/* Spacer for fixed header */}
      <div className="h-16 md:h-20" />
      
      <main>
        {/* Hero */}
        <HeroSection />
        {/* Mobile: hint demo (hero visual is desktop-only) */}
        <div className="lg:hidden container mx-auto px-6 -mt-4 mb-8">
          <HintLadderDemo />
        </div>
        <SubjectExplorer />
        <SectionBlend />

        {/* Social Proof */}
        <SocialProofSection />
        <SectionBlend />

        {/* How It Works — with drifting education pattern */}
        <div className="relative overflow-hidden">
          <ParallaxPattern />
          <HowItWorksSection />
        </div>
        <SectionBlend />

        <PersonaSwitcher />
        <SectionBlend />

        {/* Features */}
        <FeaturesSection />
        <SectionBlend />

        {/* Feedback */}
        <FeedbackSection />
        <SectionBlend />

        {/* Pricing */}
        <PricingSection />
        <SectionBlend />

        {/* FAQ — with drifting education pattern */}
        <div className="relative overflow-hidden">
          <ParallaxPattern />
          <FAQSection />
        </div>
        <SectionBlend />

        {/* CTA */}
        <CTASection />
      </main>
      
      <LandingFooter />
    </div>
  );
}
